import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';
import CurrencyFormatter from 'utils/helpers/CurrencyFormatter';

export const getAdditionalInformationDetails = (payment) => [
  {
    label: 'Es contracargo',
    value: payment?.is_chargeback ? 'Sí' : 'No',
  },
  {
    label: 'Es fraude',
    value: payment?.is_fraud ? 'Sí' : 'No',
  },
];

export const getIdentifierMPDetails = (payment) => [
  {
    label: 'ID Mercadopago',
    value: payment?.merchant_order_id,
  },
  {
    label: 'ID Pago',
    value: payment?.external_reference,
  },
];

export const getTransactionMPDetails = (transaction) => {
  if (!transaction?.payments || !Array.isArray(transaction.payments)) return [];

  const details = [
    {
      label: 'Fecha de creación',
      value: convertToMexicoTime(transaction.created),
    },
    {
      label: 'Monto',
      value: <CurrencyFormatter amount={transaction.total_amount} />,
    },
  ];

  const paymentsDetails = transaction.payments.flatMap((payment, index) => {
    const items = [];

    if (transaction.payment_source === 'multiple_payments') {
      items.push({
        label: 'Pago multiple MP',
        value: index + 1,
      });
    }

    items.push(
      {
        label: `Método de pago`,
        value: payment.payment_method,
      },
      {
        label: `Tarjeta enmascarada`,
        value: payment.masked_card,
      },
      {
        label: `Cuotas`,
        value: payment.installments === 1 ? 'Contado' : `${payment.installments} meses`,
      },
      {
        label: `Estado`,
        value: payment.status,
      },
      {
        label: `Monto de transacción`,
        value: <CurrencyFormatter amount={payment.transaction_amount} />,
      },
      {
        label: `Código de autorización`,
        value: payment.authorization_code,
      },
    );

    return items;
  });

  return [...details, ...paymentsDetails];
};
